<template>
  <div>
    <h4 class="title is-4">Monthly Expenses</h4>
    <p>Use this section for your typical monthly expenses.</p>
    <ExpenseItems
      v-bind:expense_items="expense_items"
      v-bind:total_expenses="total_expenses"
      @del-exp="deleteExp"
    />
  </div>
</template>

<script>
import ExpenseItems from "./ExpenseItems.vue";

export default {
  name: "Expenses",
  props: {
    expense_items: Array,
    total_expenses: Number,
  },
  components: {
    ExpenseItems,
  },
  data() {
    return {};
  },
  methods: {
    deleteExp(id) {
      this.$emit("del-exp", id);
    },
  },
};
</script>